namespace RecordShield.Wallet {
    export interface CreditStatementListRequest extends Serenity.ListRequest {
    }
}
